export type ThemeMode = 'system' | 'light' | 'dark'

const KEY = 'ariariko:theme'

function readStorage(key: string): string | null {
  try { return localStorage.getItem(key) } catch { return null }
}
function writeStorage(key: string, value: string) {
  try { localStorage.setItem(key, value) } catch { /* navigation privée */ }
}
function removeStorage(key: string) {
  try { localStorage.removeItem(key) } catch { /* navigation privée */ }
}

/**
 * Le thème est PAR APPAREIL, comme le mode de synchronisation (vision.md).
 * "system" retire l'attribut plutôt que d'écrire une valeur : c'est ce que
 * `tokens.css` lit pour retomber sur `prefers-color-scheme`.
 */
export function getThemeMode(): ThemeMode {
  const value = readStorage(KEY)
  return value === 'light' || value === 'dark' ? value : 'system'
}

export function setThemeMode(mode: ThemeMode) {
  if (mode === 'system') removeStorage(KEY)
  else writeStorage(KEY, mode)
  applyThemeMode(mode)
}

/** Pose l'attribut que `tokens.css` attend sur `<html>`. */
export function applyThemeMode(mode: ThemeMode) {
  if (mode === 'system') delete document.documentElement.dataset.theme
  else document.documentElement.dataset.theme = mode
}
